import React, { useState, useEffect } from "react";
import { Container, Col, Row, Card, CardBody, Table, Button } from "reactstrap";
import axios from "axios";
import { Link } from "react-router-dom";
// Import rank images
import firstPlaceImg from "../../assets/images/items/1st.png";
import secondPlaceImg from "../../assets/images/items/2nd.png";
import thirdPlaceImg from "../../assets/images/items/3rd.png";
import api from "../../api";

import coinImg from "../../assets/images/items/coin.png";
// Helper function to format a number with commas
function formatNumber(num) {
  return num.toLocaleString();
}

const CoinsRankings = () => {
  // Page state
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  // Data state for current page rankings
  const [trainers, setTrainers] = useState([]);

  // Loading and error state
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  document.title = "Coins Rankings";

  // Fetch leaderboard data for the current page
  useEffect(() => {
    const fetchLeaderboard = async () => {
      setIsLoading(true);
      setError("");
      try {
        const response = await api.get(
          `v1/coins-rankings?page=${page}&limit=${limit}`,
          { withCredentials: true },
        );
        // Adjust based on your backend response structure
        const data = response.data.data;
        const totalCount = response.data.total || 0;
        setTrainers(data);
        setTotal(totalCount);
      } catch (err) {
        console.error(err);
        setError("Failed to load leaderboard");
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeaderboard();
  }, [page, limit]);

  // Calculate total pages
  const totalPages = Math.ceil(total / limit);

  const handlePrev = () => {
    if (page > 1) {
      setPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (page < totalPages) {
      setPage((prev) => prev + 1);
    }
  };

  // Helper: Get rank image based on rank number (for top 3 rows)
  const getRankImage = (rank) => {
    if (rank === 1) return firstPlaceImg;
    if (rank === 2) return secondPlaceImg;
    if (rank === 3) return thirdPlaceImg;
    return null;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <h4 className="mb-4">Coin Rankings</h4>

                  {isLoading && <div>Loading leaderboard...</div>}
                  {error && <div className="text-danger">{error}</div>}

                  {!isLoading && !error && (
                    <div>
                      <Table striped responsive className="align-middle">
                        <thead>
                          <tr>
                            <th style={{ width: "5%" }}>Rank</th>
                            <th style={{ width: "10%" }}>Avatar</th>
                            <th>Username</th>
                            <th>Coins</th>
                          </tr>
                        </thead>
                        <tbody>
                          {trainers.map((trainer, index) => {
                            const rank = (page - 1) * limit + (index + 1);
                            return (
                              <tr key={trainer.username}>
                                <td>
                                  {rank <= 3 ? (
                                    <img
                                      src={getRankImage(rank)}
                                      alt={`${rank} rank`}
                                    />
                                  ) : (
                                    rank
                                  )}
                                </td>
                                <td>
                                  <img
                                    src={`/avatars/${trainer.avatar}.png`}
                                    alt="avatar"
                                    style={{
                                      width: 40,
                                      height: 40,
                                      borderRadius: "50%",
                                    }}
                                  />
                                </td>
                                <td>
                                  <Link
                                    to={`/playerprofile?user=${trainer.username}`}
                                    style={{
                                      textDecoration: "none",
                                      color: "white",
                                    }}
                                  >
                                    {trainer.username}
                                  </Link>
                                </td>

                                <td>
                                  <img
                                    src={coinImg}
                                    alt="Coins"
                                    style={{
                                      width: "24px",
                                      verticalAlign: "middle",
                                      marginLeft: "5px",
                                    }}
                                  />
                                  {formatNumber(trainer.coins)}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>

                      {/* Pagination Controls */}
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                          <Button
                            color="primary"
                            disabled={page <= 1}
                            onClick={handlePrev}
                          >
                            Prev
                          </Button>{" "}
                          <Button
                            color="primary"
                            disabled={page >= totalPages}
                            onClick={handleNext}
                          >
                            Next
                          </Button>
                        </div>
                        <div>
                          Page {page} of {totalPages || 1}
                        </div>
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CoinsRankings;
